// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"6e9fbb2f","107":"a3ef6427"}[chunkId] + ".chunk.css";
};